import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";

export default function PromoRibbon() {
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.8, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="promo-ribbon"
    >
      <Link
        to="/#discounts"
        className="group flex items-center justify-center gap-3 bg-gold text-ink py-3 px-4 hover:bg-gold-glow transition-colors duration-300"
      >
        <ShieldCheck className="w-4 h-4 shrink-0" />
        <span className="text-[11px] sm:text-xs uppercase tracking-[0.25em] font-medium text-center">
          Blue Light, Veterans &amp; Marshall's — 10% off · Verify your eligibility
        </span>
        <span className="text-xs transition-transform duration-300 group-hover:translate-x-1">→</span>
      </Link>
    </motion.div>
  );
}
